import api from './api';

export default async function fetchAlertRelatedTrendsearchData(userId, token) {
  const response = await api.get(`/alert_related_trendsearch_data/${userId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}




